import { JobStart, JobStatus } from '@/types/api';
import {
  timezoneOptions,
  developerTypeOptions,
  yearsOfExperienceOptions,
} from '@/utils/dropdownOptions';

const jobAvailabilityOptions = Object.keys(JobStart).map((key) => JobStart[key]);
const jobStatusOptions = Object.keys(JobStatus).map((key) =>
  key === 'ACTIVE' ? 'Open' : JobStatus[key]
);

const timezoneOverlapOptions = Array.from(
  { length: 12 },
  (_, i) => `> ${i + 1} hour${i > 0 ? 's' : ''}`
);
const jobTimezoneOverlapOptionsWithLabels = timezoneOverlapOptions.map((option, index) => ({
  value: index + 1,
  label: option,
}));

const getWorkingTimes = (period: 'AM' | 'PM'): string[] =>
  Array.from({ length: 11 }, (_, i) => `${i + 1} ${period}`);

const jobWorkingTimesOptions = [
  '12 AM',
  ...getWorkingTimes('AM'),
  '12 PM',
  ...getWorkingTimes('PM'),
];

export const textInputs = ['title', 'salaryRangeMin', 'salaryRangeMax', 'jobLink', 'numberOfDevs'];

export const dropdownOptionsMap = {
  developerType: developerTypeOptions,
  experience: yearsOfExperienceOptions,
  status: jobStatusOptions,
  whenToStart: jobAvailabilityOptions,
  timeZone: timezoneOptions,
  timeZoneOverlap: jobTimezoneOverlapOptionsWithLabels,
  workingTimes: jobWorkingTimesOptions,
};

export const fieldsAndFriendlyLabels = {
  title: 'Job Title',
  salaryRange: 'Salary Range',
  jobLink: 'Job Link',
  numberOfDevs: 'Number of Talents',
  developerType: 'Developer Type',
  experience: 'Experience',
  techs: 'Tech Stack',
  status: 'Status',
  account: 'Partner',
  whenToStart: 'When to Start',
  timeZone: 'Time Zone',
  timeZoneOverlap: 'Time Zone Overlap',
  workingTimes: 'Working Times',
};
